import { useEffect } from 'react';
import type { EditorState } from 'prosemirror-state';

import { useIsCurrentPageLive } from '@confluence/live-pages-utils/entry-points/useIsCurrentPageLive';
import { usePageState } from '@confluence/page-context';

import { createPlugin, pluginKey, pluginName } from './createPlugin';
import { getToolbarConfig } from './toolbars/getToolbarConfig';
import type { ExtensionManagerPlugin } from './createPlugin';

export const fabricExtensionManagerPlugin: ExtensionManagerPlugin = ({ api }) => ({
	name: pluginName,
	pmPlugins() {
		return [
			{
				name: pluginName,
				plugin: () => createPlugin(),
			},
		];
	},
	getSharedState(editorState?: EditorState) {
		if (!editorState) {
			return undefined;
		}

		const pluginState = pluginKey.getState(editorState);

		return {
			showAnchorLinkCopiedTooltip: pluginState?.showAnchorLinkCopiedTooltip,
		};
	},
	usePluginHook({ editorView }) {
		const isLivePage = useIsCurrentPageLive();
		const [{ contentId, spaceKey }] = usePageState();

		useEffect(() => {
			const {
				dispatch,
				state: { tr },
			} = editorView;

			tr.setMeta(pluginKey, {
				pageContext: {
					isLivePage,
					spaceKey,
					contentId,
				},
			});
			dispatch(tr);
		}, [editorView, isLivePage, spaceKey, contentId]);
	},
	pluginsOptions: {
		floatingToolbar: (...args) => getToolbarConfig(...args, api),
	},
});
